import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import './styles.scss'
import { useScreen } from '../ScreenContext'
import { useChatPanel } from '../ChatPanel/ChatPanelContext'
import Breadcrumb from '../Breadcrumb'

const GLOW_EXIT_MS = 900

export default function Body({ children }) {
    const { loading, fullWidth, bodyRef } = useScreen()
    const { open: chatOpen } = useChatPanel()
    const { pathname } = useLocation()
    const [showGlow, setShowGlow] = useState(loading)
    const [leaving, setLeaving] = useState(false)
    const exitTimer = useRef(null)

    useEffect(() => {
        bodyRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
    }, [pathname])

    useEffect(() => {
        if (loading) {
            clearTimeout(exitTimer.current)
            setShowGlow(true)
            setLeaving(false)
        } else if (showGlow) {
            setLeaving(true)
            exitTimer.current = setTimeout(() => {
                setShowGlow(false)
                setLeaving(false)
            }, GLOW_EXIT_MS)
        }
        return () => clearTimeout(exitTimer.current)
    }, [loading])

    return (
        <div className={`cs-body-outer${chatOpen ? ' cs-body-outer--chat-open' : ''}`}>
            {showGlow && (
                <div className={`cs-body-border-glow${leaving ? ' cs-body-border-glow--leaving' : ''}`}>
                    <div className="cs-body-glow-spinner" />
                </div>
            )}
            <div
                ref={bodyRef}
                className={`cs-body${loading ? ' cs-body--loading' : ''}${fullWidth ? ' cs-body--full-width' : ''}${chatOpen ? ' cs-body--chat-open' : ''}`}
            >
                <Breadcrumb />
                {children}
            </div>
        </div>
    )
}
